export const CASAS_DECIMAIS_PADRAO = 2

/**
 * Normaliza a quantidade de casas decimais configurada na licitação
 * (LicitacaoEntity.casasDecimais / LicitacaoEntity.casasDecimaisQuantidade).
 *
 * Retorna o padrão (2) quando o valor não estiver configurado ou for inválido,
 * preservando o zero como uma configuração válida.
 */
export function normalizarCasasDecimais(casasDecimais, padrao = CASAS_DECIMAIS_PADRAO) {
    if (casasDecimais === null || casasDecimais === undefined || casasDecimais === '') {
        return padrao
    }

    const casasDecimaisNumero = Number(casasDecimais)

    if (!Number.isFinite(casasDecimaisNumero) || casasDecimaisNumero < 0) {
        return padrao
    }

    return Math.trunc(casasDecimaisNumero)
}

export default {CASAS_DECIMAIS_PADRAO, normalizarCasasDecimais}
